import { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Fleet } from "../components/Fleet";
import { Packages } from "../components/Packages";
import { AddOns } from "../components/AddOns";
import { BookingForm } from "../components/BookingForm";
import { Footer } from "../components/Footer";

export default function Landing() {
  const [selectedVehicle, setSelectedVehicle] = useState("escalade");

  const handleBook = (id) => {
    setSelectedVehicle(id);
    setTimeout(() => {
      const el = document.querySelector("#book");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <div data-testid="landing-page" className="bg-black min-h-screen text-white">
      <Navbar />
      <Hero />
      <Fleet onBook={handleBook} />
      <Packages />
      <AddOns />

      <section
        id="book"
        data-testid="booking-section"
        className="relative py-24 md:py-32 border-t border-zinc-900"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-14">
            <div className="text-[10px] tracking-[0.3em] text-[#E50914] uppercase mb-4">
              ⏤ Reserve
            </div>
            <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter leading-none">
              Lock in your <span className="text-[#E50914]">date.</span>
            </h2>
            <p className="text-zinc-400 mt-6 max-w-xl mx-auto">
              Submit a request — a team member will contact you within hours to confirm your
              booking.
            </p>
          </div>
          <BookingForm initialVehicle={selectedVehicle} />
        </div>
      </section>

      <Footer />
    </div>
  );
}
